import axios from "axios";
import { toast } from "react-toastify";

const { apiUrl, adminToken } = window.config;

// axios.headers.common['Authorization'] = `Bearer ${access_token}`

export async function checkUserTenant(credentials) {
  const { data, status } = await axios(`${apiUrl}/api/userTenant/tenantListIn/${adminToken}/${credentials.username}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (status === 204) {
    toast.error(`🚫 No username found`, {
      position: "bottom-center",
      autoClose: 2000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      progress: undefined,
    });
  }
  return data;
}

export async function loginUser(credentials, { Tenant }) {
  let newCredentials = {
    Email: "string",
    Language: "string",
    Tenant: Tenant,
    Password: credentials.password,
    UserName: credentials.username,
  };
  const { data, status } = await axios
    .post(`${apiUrl}/api/login?adminToken=${adminToken}`, JSON.stringify(newCredentials), {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });

  // const { data, status } = r;

  if (status === 204) {
    toast.error(`🚫 No username found`, {
      position: "bottom-center",
      autoClose: 2000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      progress: undefined,
    });
    return;
  }
  if (status === 401) {
    toast.error(`🚫 ${data.UserMessage}`, {
      position: "bottom-center",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      progress: undefined,
    });
    return;
  }
  return data;
}

export async function logout() {
  let token = sessionStorage.getItem("AccessToken");
  await axios(`${apiUrl}/api/logout`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: token ? `Bearer ${token}` : "",
    },
  });
  return sessionStorage.removeItem("AccessToken");
}

export async function getAssetLocationList() {
  let token = sessionStorage.getItem("AccessToken");
  try {
    const { data } = await axios.get(`${apiUrl}/api/assetLocation`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: token ? `Bearer ${token}` : "",
      },
    });
    return data;
  } catch {
    return undefined;
  }
}

export async function getAssetList(txtSearch) {
  let token = sessionStorage.getItem("AccessToken");
  let uriQueryString = {
    Limit: 15,
    Page: 1,
    Exclude: [
      "Spec",
      "SerialNo",
      "CurRate",
      "Qty",
      "Salvage",
      "InitAccu",
      "TotalCost",
      "Life",
      "LifeType",
      "RemainDay",
      "RemainNet",
      "RemainTotalCost",
      "DimList",
      "RemainInfo",
    ],
    WhereGroupList: [
      {
        AndOr: "And",
        ConditionList: [
          {
            AndOr: "Or",
            Field: "AstId",
            Operator: "Like",
            Value: `%${txtSearch}%`,
          },
          {
            AndOr: "Or",
            Field: "AstName",
            Operator: "Like",
            Value: `%${txtSearch}%`,
          },
        ],
      },
    ],
  };

  const { data } = await axios.post(`${apiUrl}/api/assetRegister/search`, uriQueryString, {
    headers: {
      "Content-Type": "application/json",
      Authorization: token ? `Bearer ${token}` : "",
    },
  });

  return data.Data.map(({ RegId, Name, AstPhoto, Barcode }) => ({
    value: RegId,
    name: Name,
    photo: AstPhoto,
    barcode: Barcode,
  }));
}

export async function getAssetByRegId(RegId) {
  let token = sessionStorage.getItem("AccessToken");
  try {
    const { data } = await axios.get(`${apiUrl}/api/assetRegister/${RegId}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: token ? `Bearer ${token}` : "",
      },
    });
    return data;
  } catch {
    return undefined;
  }
}

export async function getAssetByBarcode(barcode) {
  let token = sessionStorage.getItem("AccessToken");
  let uriQueryString = {
    Limit: 1,
    WhereLike: `%${barcode}%`,
    WhereLikeFields: ["AstId", "AstName", "Astbarcode"],
    // WhereGroupList: [
    //   {
    //     AndOr: "And",
    //     ConditionList: [
    //       {
    //         AndOr: "And",
    //         Field: "AstBarCode",
    //         Operator: "=",
    //         Value: barcode,
    //       },
    //     ],
    //   },
    // ],
  };

  const { data } = await axios.post(`${apiUrl}/api/assetRegister/search`, uriQueryString, {
    headers: {
      "Content-Type": "application/json",
      Authorization: token ? `Bearer ${token}` : "",
    },
  });
  return data;
}

export async function updateAssetRegDetail(param) {
  let token = sessionStorage.getItem("AccessToken");
  const { data } = await axios.put(`${apiUrl}/api/assetRegister/${param.RegId}`, param, {
    headers: {
      "Content-Type": "application/json",
      Authorization: token ? `Bearer ${token}` : "",
    },
  });
  return data;
}

export async function addComment(param) {
  let token = sessionStorage.getItem("AccessToken");
  const { data } = await axios.post(`${apiUrl}/api/comment/`, param, {
    headers: {
      "Content-Type": "application/json",
      Authorization: token ? `Bearer ${token}` : "",
    },
  });
  return data;
}

export async function getComment(id) {
  let token = sessionStorage.getItem("AccessToken");
  const { data } = await axios.get(`${apiUrl}/api/comment/AST_Reg/${id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: token ? `Bearer ${token}` : "",
    },
  });
  return data;
}

export async function getCommentById(id) {
  let token = sessionStorage.getItem("AccessToken");
  const { data } = await axios.get(`${apiUrl}/api/comment/${id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: token ? `Bearer ${token}` : "",
    },
  });
  return data;
}

export async function downloadCommentById(id) {
  let token = sessionStorage.getItem("AccessToken");
  const { data } = await axios.get(`/api/comment/download/${id}`, {
    headers: {
      "content-Type": "application/octet-stream",
      Authorization: token ? `Bearer ${token}` : "",
      responseType: "blob",
    },
  });
  return data;
}
